import { colors } from '@/lib/analytics/colors';
import { SIZE_33 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const avgEngagementReachPostConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.facebook.avg_engagement_reach_post',
    id: 'average_engagement_on_reach_per_post',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    tooltip: 'kpi.facebook.tooltip_avg_engagement_reach_post',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    mergedData: true,
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_33,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
